/** Local images served from public/assets */
const asset = (filename) =>
  `${process.env.PUBLIC_URL}/assets/${encodeURIComponent(filename)}`;

/** Product brand — use these instead of hardcoding the name in components. */
export const BRAND_NAME = "Gneiss";
export const BRAND_DOMAIN = "https://wa.gneisssolutions.com/";

export const ASSETS = {
  brandName: BRAND_NAME,
  brandDomain: BRAND_DOMAIN,
  favicon: asset("logo.png"),
  logo: asset("whatsappimage-DTXVT34p.webp"),
  whatsappBadge: asset("whatsapplogo-D1q7B6cc.png"),
  bluetickBadge: asset("bluetick-CpV3aIjT.png"),
  brandLogo: asset("logo.png"),
  loginBg: asset("login-hero-ai.png"),
  homeHero: asset("channel-waba-header.png"),
  notFound: asset("notfound-DM54_X0C.png"),
  slides: [
    asset("loginimage-BpeHjAHq.webp"),
    asset("boysmartphone-Div68Iby.webp"),
    asset("creatingaccount-BmGMoklU.webp"),
  ],
  partners: [
    asset("collegejalebi-Cxr64xNG.png"),
    asset("kathariya-BiQsruYP.png"),
    asset("W3-OjPOFBnd.png"),
    asset("atharva-BLFNBqI-.webp"),
    asset("hrmatrics-DW11kq8Z.png"),
    asset("bluelife-oJWcut0d.png"),
    asset("torero-BNNMYbbD.png"),
    asset("spineinfotech-H7C8ltJ4.webp"),
    asset("mps-NQW2DgtB.png"),
  ],
  registerHero: asset("register-hero-ai.png"),
  registerDecor: [
    asset("whatsappimage-DTXVT34p.webp"),
    asset("messageblob-DzRCPAre.png"),
    asset("phonemessage-ekOS_LpI.png"),
  ],
  checkmark: asset("checkmark-ChB-cUcV.png"),
  channelHeader: asset("channel-waba-header.jpg"),
  chatBg: asset("chat-bg.png"),
};
